export default {
  getRecordList: '/v3/mapping/bd/train/client/core/learnHistory'
}
